{
  "labels": {
    "izberi": "Select language",
    "buttons": {
      "odpriJezik": "Set language",
      "potrdiJezik": "Change",
      "generiranje": "Changing"
    }
  },
  "obvestila": {
    "vprasanjeMenjave": "You are about to change the application's display language. Do you want to proceed?",
    "uspesno": "User interface language successfully changed",
    "napakaPosodabljanja": "Error updating data"
  }
}